/**
 * @author PengWen
 * @description 登录实时人数管理
 * @Date 2023/06/21
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, utils_tool } from '../../../tool';
import { templateConfig, reduxTemplateConfig } from "./detailConfig";
let { Session } = utils_tool;

let { WizContainer, WizReduxTemplate } = framework_tool;

class AuthLoginLogDetailManager extends WizContainer {
    componentName = 'AuthLoginLogDetailManager';

    constructor(props) {
        super(props);
        this.state = {
        }
        const { history } = props;
        let searchProps = {};
        if (history.location && history.location.pathname === '/authLoginLogListDetail') {
          console.log("history",history)
          if (history.location && history.location.record) {
            searchProps = history.location.record;
            Session.set('searchProps', searchProps)
          } else {
            searchProps = Session.get('searchProps') || {};
          }
        }
        this.searchProps = searchProps;
        console.log("this.searchProps",this.searchProps)
    }

    _handleCMD(nextProps, nextState, key){
        let o = nextProps[key];
        if (o['success']) {
          wizNotice.success(o['msg']);
          return true;
        } else {
          wizNotice.error(o['msg']);
          return false;
        }
    }

    _getPushProps = () => {
        let { location } = this.props;
        let searchProps = location['record'] && location['record'] && location['record']['searchProps'] ? location['record']['searchProps'] : undefined
        if (!searchProps) {
          searchProps = this.searchProps['searchProps'];
        }
        let templateConfigProps = { searchProps }
        let apiProps = {}
        if ((searchProps && searchProps['data'] && searchProps['data'].length)) {
          let data = searchProps['data'][0]
          console.log("data",data)
          apiProps = {
            platform: data,
            keepInitApiParams: true
          }
        }
        return { templateConfigProps, apiProps }
    }

    _render() {
        let pushProps = this._getPushProps()
        console.log("pushProps",pushProps)
        let _reduxTemplateConfig = reduxTemplateConfig({
          templateConfig,
          apiDataFormat: {
            logout: this._handleCMD
          },
          ...pushProps['apiProps']
        })
        return <WizReduxTemplate {..._reduxTemplateConfig} />
    }


}

const mapStateToProps = (state, ownProps) => {
    return {
    }
};

export default connect(mapStateToProps)(AuthLoginLogDetailManager);
